module.exports = __webpack_public_path__ + "img/flo.49e763ec.svg";